import { BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showIcon?: boolean;
  className?: string;
  variant?: "default" | "light";
}

export function Logo({ size = "md", showIcon = true, className, variant = "default" }: LogoProps) {
  const sizeClasses = {
    sm: {
      container: "gap-1.5",
      icon: "h-4 w-4",
      daily: "text-base",
      hisaab: "text-base",
    },
    md: {
      container: "gap-2",
      icon: "h-5 w-5",
      daily: "text-lg",
      hisaab: "text-lg",
    },
    lg: {
      container: "gap-2.5",
      icon: "h-7 w-7",
      daily: "text-2xl",
      hisaab: "text-2xl",
    },
  };

  const s = sizeClasses[size];

  return (
    <div
      className={cn("flex items-center", s.container, className)}
      data-testid="logo"
    >
      {showIcon && (
        <div className={cn("rounded-md p-1.5 flex items-center justify-center", variant === "light" ? "bg-white/20" : "bg-primary")}>
          <BookOpen
            className={cn(s.icon, variant === "light" ? "text-white" : "text-primary-foreground")}
            strokeWidth={2.5}
          />
        </div>
      )}
      <div className="flex items-baseline">
        <span
          className={cn(
            s.daily,
            "font-light tracking-tight",
            variant === "light" ? "text-white/80" : "text-muted-foreground",
          )}
        >
          Daily
        </span>
        <span className={cn(s.hisaab, "font-bold tracking-tight", variant === "light" ? "text-white" : "text-primary")}>
          Hisaab
        </span>
      </div>
    </div>
  );
}
